import {
	Box,
	Button,
	ClickAwayListener,
	Collapse,
	Divider,
	FormControlLabel,
	FormGroup,
	List,
	ListItemButton,
	ListItemText,
	Radio,
	Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { usePagination } from 'hooks/usePagination';
import { useBoundStore } from 'useStore';
import LightTooltip from 'views/Components/Shared/Components/LightTooltip';
import useOwnerProductMasterData from '../Queries/ProductMasterOwner';
import useAuth from 'hooks/useAuth';

function Options({ closeTooltip }) {
	const [open, setOpen] = useState(null);
	const owners = useOwnerProductMasterData();
	const allOwners = owners.data;

	const { user } = useAuth();

	const isAdmin = user.permissions.includes('ProductViewManage:Admin');
	const isViewer = user.permissions.includes('ProductViewManage:View');

	const selectedOwners = useBoundStore(
		(state) => state.productMasterStSelectedOwners
	);

	const toggleSelectedOwners = useBoundStore(
		(state) => state.toggleProductMasterStSelectedOwners
	);
	const clearSelectedOwners = useBoundStore(
		(state) => state.clearProductMasterStSelectedOwners
	);

	const { paginationModel, handlePaginationChange } = usePagination();

	const handleClick = (filter) => {
		setOpen((prev) => (prev === filter ? null : filter));
	};

	const ownersToDisplay = (() => {
		if (isViewer && !isAdmin) {
			const userFullName = user.name;

			if (
				allOwners?.some(
					(owner) => `${owner.name} ${owner.lastname}` === userFullName
				)
			) {
				return [
					{ name: user.given_name, lastname: user.family_name, id: user.id },
				];
			}
			return [];
		}
		return allOwners;
	})();

	const handleClearAndApplyFilters = () => {
		clearSelectedOwners();
		handlePaginationChange({ ...paginationModel, page: 0 });
	};

	return (
		<List
			sx={{ width: '340px', maxWidth: 340, bgcolor: 'background.paper' }}
			component="nav"
			aria-labelledby="nested-list-subheader"
			subheader={
				<Stack
					direction="row"
					spacing={3}
					alignItems="center"
					justifyContent="space-between"
				>
					<Typography
						sx={{
							color: 'rgba(0, 0, 0, 0.87)',
							fontFamily: 'Roboto',
							fontStyle: 'normal',
							fontSize: '16px',
							lineHeight: '24px',
							fontWeight: '700',
							letterSpacing: '0.15px',
							padding: '12px',
						}}
					>
						Filtrar por:
					</Typography>
				</Stack>
			}
		>
			<Divider />

			<ListItemButton onClick={() => handleClick('owners')}>
				<ListItemText primary="Owners" />
				{open === 'owners' ? <ExpandLess /> : <ExpandMore />}
			</ListItemButton>
			<Collapse in={open === 'owners'} timeout="auto" unmountOnExit>
				<List component="div" disablePadding>
					<Box
						sx={{
							maxHeight: '200px',
							overflowY: 'auto',
						}}
					>
						<FormGroup sx={{ pl: 2 }}>
							{ownersToDisplay?.map((owner) => {
								const isChecked = selectedOwners.includes(
									`${owner.name} ${owner.lastname}`
								);
								return (
									<FormControlLabel
										key={owner.id}
										control={
											<Radio
												color="secondary"
												checked={isChecked}
												onChange={() => {
													toggleSelectedOwners(
														`${owner.name} ${owner.lastname}`
													);

													handlePaginationChange({
														...paginationModel,
														page: 0,
													});
												}}
											/>
										}
										label={`${owner.name} ${owner.lastname}`}
									/>
								);
							})}
						</FormGroup>
					</Box>
				</List>
			</Collapse>

			<Divider />

			<Button
				color="secondary"
				onClick={closeTooltip}
				sx={{
					mt: 1,
				}}
			>
				CERRAR
			</Button>
		</List>
	);
}

export default function FiltersOptions() {
	const selectedOwners = useBoundStore(
		(state) => state.productMasterStSelectedOwners
	);
	const [open, setOpen] = useState(false);

	const OwnerFilter = selectedOwners.length > 0 ? 1 : 0;

	const appliedFilters = OwnerFilter;

	const handleTooltipClose = () => {
		setOpen(false);
	};

	const handleToggleTooltip = () => {
		setOpen((prev) => !prev);
	};

	return (
		<ClickAwayListener onClickAway={handleTooltipClose}>
			<div>
				<LightTooltip
					PopperProps={{
						disablePortal: true,
					}}
					onClose={handleTooltipClose}
					open={open}
					disableFocusListener
					disableHoverListener
					disableTouchListener
					title={<Options closeTooltip={handleTooltipClose} />}
				>
					<Stack
						direction="row"
						alignItems="center"
						justifyContent="space-between"
						sx={{
							padding: '12px',
							width: '182px',
							borderRadius: '4px',
							border: '1px solid rgba(0, 0, 0, 0.23)',
							cursor: 'pointer',
						}}
						onClick={handleToggleTooltip}
					>
						<Typography
							sx={{
								color: '#00000099',
								fontSize: '16px',
								fontFamily: 'Roboto',
								fontStyle: 'normal',
								fontWeight: '400',
								lineHeight: '24px',
								letterSpacing: '0.15px',
							}}
						>
							{appliedFilters > 0
								? `Filtros (${appliedFilters})`
								: 'Más filtros'}
						</Typography>
						<FilterListIcon
							sx={{
								fill: '#0000008F',
								width: '24px',
								height: '24px',
							}}
						/>
					</Stack>
				</LightTooltip>
			</div>
		</ClickAwayListener>
	);
}
